import { render, staticRenderFns } from "./RegisterShipperAccountPage.vue?vue&type=template&id=eb5be5f6&scoped=true&"
import script from "./RegisterShipperAccountPage.vue?vue&type=script&lang=js&"
export * from "./RegisterShipperAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterShipperAccountPage.vue?vue&type=style&index=0&id=eb5be5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5be5f6",
  null
  
)

export default component.exports